<div class="tile-container" [ngStyle]="getGridListStyle" *ngIf="containerConfig">
    <div class="tile" *ngFor="let map of containerConfig.maps;trackBy: trackByIdentity;" [style.minHeight.px]="'198.5'">
        <anatomic-map
            #map
            [map]="map"
            [currentColor]="currentColor"
            [externalSegmentSelected]="selectedSegment"
            [isMapSelected]="_isThisMapSelected(map)"
            [data]="data"
            [segmentLabel]="segmentLabelType"
            [readOnly]="readOnly"
            [hasTooltips]="isWithTooltip"
            [isWithViewId]="isWithViewId"
            [upperLabel]="viewTopLabel"
            [lowerLabel]="viewBottomLabel"
            [viewSideLenght]="viewsSideLenght"
            (selectionEvent)="onSelectionEvent($event)"
            (dataUpdated)="onDataUpdated($event)"
        ></anatomic-map>
    </div>
</div>
<map-legend
    [ngStyle]="getLegendStyle"
    [legend]="legendColors"
    [isHorizontal]="isHorizontal"
    [buttonsConfiguration]="buttonsConf"
    [actualColor]="currentColor"
    [readOnly]="readOnly"
    (colorChanged)="onLegendSelection($event)"
    (buttonClicked)="onLegendBtnClick($event)"
>
    <ng-content extra-buttons-before select="[extra-buttons-legend]"></ng-content>
</map-legend>
